import { render, staticRenderFns } from "./BeautyDetailsIcon.vue?vue&type=template&id=79d0e32a&"
import script from "./BeautyDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./BeautyDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports